/**
 * Tooltip ⓘ compartilhado. Desenhado num portal no <body> com posição fixa —
 * nunca é cortado por tabela/card com overflow (o bug do "Sinistralidade" na
 * 1ª linha da tabela de indicadores). Abre para cima; se não couber, para
 * baixo; e encosta nas bordas da tela em vez de sair dela. Fecha ao rolar.
 */
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Info } from "lucide-react";

const MARGEM = 8;

export default function InfoTip({ texto, w = 250, cor = "#7f8c8d", tamanho = 13, style }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(null);

  const abrir = () => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const vw = window.innerWidth, vh = window.innerHeight;
    const largura = Math.min(w, vw - 2 * MARGEM);
    const left = Math.min(Math.max(r.left + r.width / 2 - largura / 2, MARGEM), vw - largura - MARGEM);
    const espacoCima = r.top - MARGEM, espacoBaixo = vh - r.bottom - MARGEM;
    const emCima = espacoCima >= 160 || espacoCima >= espacoBaixo;
    setPos(emCima
      ? { left, largura, bottom: vh - r.top + 6, maxHeight: espacoCima - 6 }
      : { left, largura, top: r.bottom + 6, maxHeight: espacoBaixo - 6 });
  };
  const fechar = () => setPos(null);

  // Rolar (a página ou qualquer container) deixaria o balão solto: fecha.
  useEffect(() => {
    if (!pos) return undefined;
    window.addEventListener("scroll", fechar, true);
    window.addEventListener("resize", fechar);
    return () => { window.removeEventListener("scroll", fechar, true); window.removeEventListener("resize", fechar); };
  }, [pos]);

  if (!texto) return null;
  return (
    <span ref={ref} style={{ display: "inline-block", marginLeft: 5, ...style }}
      onMouseEnter={abrir} onMouseLeave={fechar} onFocus={abrir} onBlur={fechar} tabIndex={0}
      aria-label={typeof texto === "string" ? texto : undefined}>
      <Info size={tamanho} style={{ color: cor, cursor: "help", verticalAlign: "middle" }} />
      {pos && createPortal(
        <span role="tooltip" style={{
          position: "fixed", zIndex: 10000, left: pos.left, width: pos.largura,
          top: pos.top, bottom: pos.bottom, maxHeight: pos.maxHeight, overflowY: "auto",
          background: "#1f2937", color: "#fff", fontSize: 12, fontWeight: 400,
          padding: "8px 10px", borderRadius: 6, boxShadow: "0 4px 14px rgba(0,0,0,.28)",
          lineHeight: 1.45, textAlign: "left", whiteSpace: "normal", pointerEvents: "none",
        }}>{texto}</span>,
        document.body,
      )}
    </span>
  );
}
